
export const THEME_PALLETE = {
    // --- Primary ---
    primary: "#6366f1",
    primaryDark: "#4f46e5",
    primarySoft: "#e0e7ff",
    accent: "#8b5cf6",
    primaryGradient: "linear-gradient(90deg, #4f52d9, #7c4fe0)",
    primaryLight: "#eef2ff",
    primaryBorder: "#c7d2fe",

    // --- Brand gradients ---
    gradientPrimary: "linear-gradient(135deg, #6366f1, #4f46e5)",
    gradientBrand: "linear-gradient(135deg, #8b5cf6, #6366f1)",
    gradientPrimarySoft: "linear-gradient(135deg, #eef2ff, #e0e7ff)",

    // --- Semantic ---
    success: "#10b981",
    successLight: "#ecfdf5",
    warning: "#f59e0b",
    warningLight: "#fef3c7",
    error: "#ef4444",
    errorLight: "#fef2f2",
    info: "#3b82f6",
    infoLight: "#eff6ff",

    // --- Text ---
    textPrimary: "#0f172a",
    textHeading: "#1e293b",
    textSecondary: "#64748b",
    textMuted: "#94a3b8",

    // --- Backgrounds ---
    bgPage: "#f8fafc",
    bgCard: "#ffffff",
    bgSection: "#fafbfc",
    bgInput: "#ffffff",

    // --- Borders ---
    border: "#f1f5f9",
    borderInput: "#e2e8f0",

    // --- Shadows ---
    shadowSubtle: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)",
    shadowElevated: "0 4px 12px rgba(0,0,0,0.06), 0 2px 4px rgba(0,0,0,0.03)",
    shadowStrong: "0 20px 60px rgba(0,0,0,0.15), 0 4px 16px rgba(0,0,0,0.08)",
    shadowPrimary: "0 6px 22px rgba(99,102,241,0.55)",

    // --- Border Radii ---
    radiusLg: "16px",
    radiusMd: "12px",
    radiusSm: "8px",
    radiusXs: "6px",

    // --- Sidebar ---
    sidebarBg: "#1e293b",
    sidebarHover: "rgba(255,255,255,0.08)",
    sidebarActive: "linear-gradient(180deg, #6366f1, #8b5cf6)",

    // --- Legacy (kept for backward compatibility) ---
    purple: "#6366f1",
    green: "#10b981",
    orange: "#f59e0b",
    red: "#ef4444",
    blue: "#3b82f6",
    gray: "#94a3b8",
    darkgray: "#333333",
    lightgray: "#edeced",
    white: "#ffffff",
    black: "#000000",
    lightblack: "#0f172a",
    paleBlue: "#C8E7F1",
    paleRed: "#FFCCCC",
}
